/**
 * The widget's icons, one stroke weight and one 24-unit grid, so a phone in
 * the launcher and a phone in the panel are the same drawing.
 */

import { html, svg, type SVGTemplateResult } from "lit";

function icon(body: SVGTemplateResult) {
  return html`<svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >${body}</svg>`;
}

const PHONE = svg`<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />`;

export const callIcon = () => icon(PHONE);

export const chatIcon = () =>
  icon(svg`<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />`);

/** The phone turned down: hanging up. */
export const endCallIcon = () =>
  icon(svg`<g transform="rotate(135 12 12)">${PHONE}</g>`);

export const micIcon = () =>
  icon(svg`<path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3z" /><path d="M19 10v2a7 7 0 0 1-14 0v-2" /><line x1="12" y1="19" x2="12" y2="22" />`);

export const micOffIcon = () =>
  icon(svg`<line x1="2" y1="2" x2="22" y2="22" /><path d="M18.89 13.23A7 7 0 0 0 19 12v-2" /><path d="M5 10v2a7 7 0 0 0 12 5" /><path d="M15 9.34V5a3 3 0 0 0-5.68-1.33" /><path d="M9 9v3a3 3 0 0 0 5.12 2.12" /><line x1="12" y1="19" x2="12" y2="22" />`);

export const sendIcon = () =>
  icon(svg`<line x1="12" y1="19" x2="12" y2="5" /><polyline points="5 12 12 5 19 12" />`);

export const closeIcon = () =>
  icon(svg`<line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />`);

export const backIcon = () =>
  icon(svg`<polyline points="15 18 9 12 15 6" />`);

export const chevronDownIcon = () =>
  icon(svg`<polyline points="6 9 12 15 18 9" />`);
